import { evaluationState } from "@/state/Evaluations";
import { annotationState } from "@/state/Annotations";
import "@/components/feedback/feedback_table";
import "@/components/code_viewer";
import "@/components/next_activity_callout";

window.dodona.setEvaluationId = (id) => (evaluationState.id = id);
window.dodona.setAnnotationVisibility = (visibility) => (annotationState.visibility = visibility);
